import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ffaa9b5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_70%_110%,rgba(255,122,47,0.28),transparent_60%),radial-gradient(ellipse_60%_50%_at_10%_0%,rgba(213,155,106,0.12),transparent_70%)]" }, null, -1))
const _hoisted_2 = { class: "relative grid items-center gap-16 lg:grid-cols-2" }
const _hoisted_3 = { class: "relative z-10 text-center lg:text-left" }
const _hoisted_4 = { class: "mt-8 font-display text-5xl font-bold leading-[1.05] sm:text-6xl xl:text-7xl" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-full w-full animate-glow bg-[radial-gradient(closest-side,rgba(255,122,47,0.32),rgba(213,155,106,0.12)_45%,rgba(213,155,106,0.04)_70%,transparent_100%)]" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex h-10 w-6 justify-center rounded-full border border-copper/40 pt-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h-2 w-1 animate-scrollhint rounded-full bg-copper" })
], -1))

import { onMounted, ref } from "vue";
import ContainerComponent from "@/components/base/ContainerComponent.vue";
import EmberCanvas from "@/components/base/EmberCanvas.vue";
import SculpturePour from "@/components/base/SculpturePour.vue";
import { scrollToSection } from "@/composables/scrollTo";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeroComponent',
  setup(__props) {

const words = [
  { text: "El", molten: false },
  { text: "metal", molten: false },
  { text: "hecho", molten: false },
  { text: "obras", molten: true },
  { text: "maestras", molten: true },
];

// eslint-disable-next-line @typescript-eslint/no-var-requires
const sculpture: string = require("@/assets/figura-1.png");
const pouring = ref(false);

const ready = ref(false);
const mx = ref(0);
const my = ref(0);

const onMove = (e: MouseEvent) => {
  mx.value = e.clientX / window.innerWidth - 0.5;
  my.value = e.clientY / window.innerHeight - 0.5;
};

onMounted(() => requestAnimationFrame(() => (ready.value = true)));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    id: "inicio",
    class: "grain relative flex min-h-screen items-center overflow-hidden pb-20 pt-32",
    onMousemove: onMove,
    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (mx.value = my.value = 0))
  }, [
    _hoisted_1,
    _createVNode(EmberCanvas),
    _createVNode(ContainerComponent, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              class: _normalizeClass(["eyebrow intro", { 'is-in': ready.value }]),
              style: {"--d":"0ms"}
            }, " Fundición artística · Piezas a la medida ", 2),
            _createElementVNode("h1", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(words, (word, i) => {
                return _createElementVNode("span", {
                  key: word.text + i,
                  class: _normalizeClass(["intro mr-[0.25em] inline-block", [{ 'is-in': ready.value }, word.molten && 'text-molten']]),
                  style: _normalizeStyle({ '--d': `${200 + i * 120}ms` })
                }, _toDisplayString(word.text), 7)
              }), 64))
            ]),
            _createElementVNode("p", {
              class: _normalizeClass(["intro mx-auto mt-8 max-w-xl text-lg leading-relaxed text-ivory/60 lg:mx-0", { 'is-in': ready.value }]),
              style: {"--d":"900ms"}
            }, " Fundimos, moldeamos y pulimos el metal hasta convertirlo en esculturas, medallas, trofeos y piezas únicas que cuentan tu historia. ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["intro mt-12 flex flex-col items-center gap-4 sm:flex-row sm:justify-center lg:justify-start", { 'is-in': ready.value }]),
              style: {"--d":"1100ms"}
            }, [
              _createElementVNode("button", {
                class: "btn-molten",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(scrollToSection)('contacto')))
              }, [
                _createTextVNode(" Cotiza tu pieza "),
                _hoisted_5
              ]),
              _createElementVNode("button", {
                class: "btn-ghost",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(scrollToSection)('servicios')))
              }, " Ver servicios ")
            ], 2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["intro intro-soft relative mx-auto aspect-square w-full max-w-[520px]", { 'is-in': ready.value }]),
            style: {"--d":"400ms"}
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["pointer-events-none absolute -inset-[15%] transition-[transform,opacity] duration-1000", pouring.value ? 'scale-110 opacity-100' : 'opacity-75'])
            }, _hoisted_7, 2),
            _createElementVNode("div", {
              class: "absolute -inset-[6%] transition-transform duration-300 ease-out",
              style: _normalizeStyle({ transform: `translate3d(${mx.value * 18}px, ${my.value * 18}px, 0)` })
            }, [
              _createVNode(SculpturePour, {
                src: _unref(sculpture),
                alt: "Escultura de metal de la Dama de la Justicia",
                "start-delay": 700,
                onPouring: _cache[2] || (_cache[2] = ($event: any) => (pouring.value = $event))
              }, null, 8, ["src"])
            ], 4)
          ], 2)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("button", {
      class: "absolute bottom-8 left-1/2 hidden -translate-x-1/2 flex-col items-center gap-3 text-[10px] uppercase tracking-[0.4em] text-ivory/40 md:flex",
      "aria-label": "Desplazarse a servicios",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(scrollToSection)('servicios')))
    }, [
      _createTextVNode(" Descubre "),
      _hoisted_8
    ])
  ], 32))
}
}

})